module.exports = __webpack_public_path__ + "static/media/paint2.08216198.jpg";